
























































































/** @format */

import dynamicComp from '@root/common/mixins/list-page/dynamicComp.vue';
import moment from 'moment';
import mixedUtils from '@root/common/mixins/list-page/utils.js';
import { Component, Prop, Vue, Mixins, Inject } from 'vue-property-decorator';
import Render from '../base/render';
import { IFieldInfoListItem } from '@root/types/component';
import version1FieldInfoList from '../field-info-list/index.vue';
import lodash from 'lodash';
// import http from '@/utils/http'
@Component({
  components: {
    Render,
    dynamicComp
  }
})
export default class superFieldInfoList extends Mixins(version1FieldInfoList) {
  // 列数
  @Prop({ default: 3 })
  column!: number;

  name = 'superFieldInfoList';

  @Prop()
  where!: string;
  // 初始可见行数
  @Prop()
  initRow!: number;

  @Prop({ default: 'ALL' })
  group!: any;

  // @Prop({ default: '' })
  // refLocationInVM?: string

  @Prop()
  vm?: Object;
  // @Inject('MIXIN_VM') MIXIN_VM
  @Prop()
  detailModel!: Object;

  // 字段配置
  @Prop({ default: () => [] })
  fields!: IFieldInfoListItem[];

  // 数据
  @Prop()
  data!: {
    [prop: string]: string | number;
  };

  // 标签宽度
  @Prop({ default: 100 })
  labelWidth!: number;
  form = null;
  // 间隔
  @Prop({ default: 100 })
  gap!: number;

  mixedUtils = mixedUtils;
  initHeight = 0;
  computedConfig = null;
  fold = true;
  triggerVisible = false;

  $refs!: {
    items: HTMLElement[];
    list: HTMLElement;
  };

  get wrapClasses() {
    return [
      'x-field-info-list-wrap',
      {
        'x-field-info-list-wrap--fold': this.fold,
        'x-field-info-list-wrap--with-trigger': this.triggerVisible
      }
    ];
  }

  get overflow() {
    const row = Math.ceil(this.fields.length / this.column);

    return this.initRow && this.initRow < row;
  }

  get wrapStyles() {
    let styles: {
      [prop: string]: string;
    } = {};
    // 指定折叠并且实际行数大于初始行数时才限制容器高度
    if (this.fold && this.overflow) {
      styles.height = `${this.initHeight}px`;
    }
    return styles;
  }

  /**
   * 标签样式
   */
  get labelStyle() {
    return {
      width: typeof this.labelWidth === 'undefined' ? '100%' : `${this.labelWidth}px`
    };
  }

  get listClasses() {
    return [
      'x-field-info-list',
      {
        'x-field-info-list--inline': typeof this.labelWidth !== 'undefined'
      }
    ];
  }

  /**
   * 样式
   */
  get fieldInnerStyles() {
    return {
      marginRight: `${this.gap}px`
    };
  }
  validateForm(cb) {
    let self = this;
    this.form.getForm().validateFields(function() {
      cb.call(self, arguments);
    });
  }

  getFormValues() {
    return this.form.getForm().getFieldsValue();
  }

  handleDynamicCompUpdate(v, compDefine, httpKey) {
    this.$nextTick(() => {
      mixedUtils.log('updat args--:', v, httpKey, compDefine);
      mixedUtils.log('http key and v--:', httpKey, v, typeof v);
      try {
        if (compDefine.rules.filter(item => 'type' in item).reverse()[0].type == 'number') {
          v = v - 0;
        }
      } catch (e) {
        console.warn('e---:', e);
      }
      //       if (this.refLocationInVM != '') {
      //         try{
      // mixedUtils.getDataByModel(this.vm,this.refLocationInVM).form.getForm().getFieldsValue()
      //         }catch(e){
      //           void 0;
      //         }
      //       }
      //       setTimeout(() => {
      this.form.getForm().setFieldsValue({
        [httpKey]: v
      });
      // }, 500)
    });
  }

  loopedFields2AntTableDefine(fieldDefine) {
    let outerHttpKey = fieldDefine.httpKey,
      // @ts-ignore
      tableData = mixedUtils.getDataByModel(this.vm.detailModel.data, outerHttpKey),
      antTableDefine = fieldDefine.fields.map(item => ({ dataIndex: item.attrs.httpKey, title: item.attrs.label }));
    // SUPER_FIELD_INFO_LIST.computedConfig[1].fieldsConfigBeforeTransform.httpKey

    mixedUtils.log('tableData and ant table define--:', tableData, antTableDefine);
    return {
      // @ts-ignore
      tableColumns: [].concat(this.vm.generateTableLeftIndexColumn()).concat(antTableDefine),
      data: tableData
    };
  }

  initialFieldConfig() {
    mixedUtils.log('initial field config was invoked--');
    let arr = [];
    // @ts-ignore
    this.vm.detailModel.config
      .filter(item => (this.group == 'ALL' ? true : this.group.includes(item.groupName)))
      .forEach((item, index) => {
        let renderType = item.renderType || 'NORMAL';
        if (renderType == 'LOOP') {
          let fieldsConfigBeforeTransform = lodash.cloneDeep(item);
          item.fieldsConfigBeforeTransform = fieldsConfigBeforeTransform;
          item.antTableDefine = this.loopedFields2AntTableDefine(item.fieldsConfigBeforeTransform);
          let fields = [];
          // @ts-ignore
          let subArr = mixedUtils.getDataByModel(this.vm.detailModel.data, item.httpKey);
          mixedUtils.log('subArr--:', subArr);
          subArr.forEach((subItem, subIndex) => {
            item.fields.forEach(fieldConfig => {
              mixedUtils.log('fieldConfig--:', fieldConfig);
              // fields.push(
              //   this.vm.mixedUtils.deepExtend(fieldConfig, {
              //     attrs: {
              //       httpKey: item.httpKey + '.' + subIndex + '.' + fieldConfig.attrs.httpKey,
              //     },
              //   }),
              // )
              fields.push({
                ...fieldConfig,

                attrs: {
                  ...fieldConfig.attrs,
                  httpKey: item.httpKey + '.' + subIndex + '.' + fieldConfig.attrs.httpKey
                }
              });
            });
          });
          arr.push({
            ...item,
            renderType: 'NORMAL',
            fields: fields
          });
        } else {
          arr.push(lodash.cloneDeep(item));
        }
      });

    arr.forEach(item => {
      item.fields.forEach(field => {
        // alert(field.attrs.httpKey)
        if (
          'initialValue' in field &&
          // @ts-ignore
          mixedUtils.getDataByModel(this.vm.detailModel.data, field.attrs.httpKey) != null
        ) {
          // debugger
          // @ts-ignore
          let modelV = mixedUtils.getDataByModel(this.vm.detailModel.data, field.attrs.httpKey);
          if (field.comp.endsWith('aDatePicker')) {
            // console.log('moment v--:', moment(mixedUtils.getDataByModel(this.vm.detailModel.data, field.attrs.httpKey)))
            field.initialValue = moment(modelV || field.initialValue || undefined);
          } else {
            if (field.useModelDataWhenInitial != false) {
              field.initialValue = typeof modelV === 'string' && modelV.trim() != '' ? modelV : field.initialValue;
            }
          }
        }

        this.$nextTick(() => {
          this.form.getForm().setFieldsValue({
            [field.attrs.httpKey]: field.initialValue
          });
        });
      });
    });

    this.computedConfig = arr;
    // debugger
  }

  // created() {
  //   let B_DETAIL_MODEL_CLEAR_CB = lodash.debounce(() => {
  //     this.computedConfig = null
  //   }, 500)

  //   this.vm.evtBus.$on('B_DETAIL_MODEL_CLEAR', B_DETAIL_MODEL_CLEAR_CB)
  // }
  created() {
    this.form = this.$form.createForm(this, { name: 'coordinated' });
  }
  mounted() {
    // debugger
    // @ts-ignore
    this.vm.addVM2Window('SUPER_FIELD_INFO_LIST', this);
    // this.vm = mixedUtils.closestVM(this, 'filterParam')
    // this.vm = this.MIXIN_VM()
    mixedUtils.log('MIXIN_VM--:', this, this.vm);
    // mixedUtils.log(`mixedUtils.closestVM(_self,'filterParam')`, mixedUtils.closestVM(this, 'filterParam'))
    this.initialFieldConfig();
    // @ts-ignore
    mixedUtils.log('detailModeldetailModeldetailModel--:', this.vm.detailModel, this.column);
    if (this.overflow) {
      const itemHeight = this.$refs.items[0].clientHeight;
      this.initHeight = itemHeight * this.initRow;
      this.updateContainer();
    }
    mixedUtils.log('computed config--:', this.computedConfig);
    // @ts-ignore
    this.vm.evtBus.$emit('B_UPDATE_DETAIL_MODEL_CONFIG', this.computedConfig);
  }

  toggle() {
    this.fold = !this.fold;
  }
  // @ts-ignore
  fieldStyles(field: IFieldInfoListItem, groupConfig: Object) {
    // mixedUtils.log('field--:', field, groupConfig)
    // @ts-ignore
    const unitPercentage = 100 / (groupConfig.column || this.column);
    const percentage = field.colspan ? unitPercentage * field.colspan : unitPercentage;
    return {
      width: `${percentage}%`
    };
  }

  updateContainer() {
    this.triggerVisible = this.$refs.list && this.$refs.list.clientHeight > this.initHeight;
  }
}
